export enum Types {
	ANDAMENTO_PROCESSO_REQUEST = '@DETRAN-CRV/ANDAMENTO_PROCESSO_REQUEST',
	ANDAMENTO_PROCESSO_SUCCESS = '@DETRAN-CRV/ANDAMENTO_PROCESSO_SUCCESS',
	ANDAMENTO_PROCESSO_FAILURE = '@DETRAN-CRV/ANDAMENTO_PROCESSO_FAILURE',
	ANDAMENTO_PROCESSO_CLEAR = '@DETRAN-CRV/ANDAMENTO_PROCESSO_CLEAR',
}

export interface andamentoProcesso {
	status: number;
	data: ficha | null;
}

interface ficha {
	ficha: {
		anoFicha: number;
		chassi: string;
		codigoSSP: number;
		dataEmissaoDocumento: string;
		dataHoraExlcusao: string;
		dataInclusaoFicha: string;
		dataInclusaohistorico: string;
		municipio: {
			codigo: number;
			nome: string;
		};
		numeroFicha: number;
		opcao: string;
		placa: string;
		planilhaRenavam: string;
		renavam: number;
		retornoBin: string;
		retornoConsistencia: string;
		status: string;
	};
}
